import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { SaleDocumentGetIdByExternalIdQuery, SaleDocumentGetIdByExternalIdQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(SaleDocumentGetIdByExternalIdQuery)
@Wrapper(SaleDocumentGetIdByExternalIdQueryHandlerBase)
export class SaleDocumentGetIdByExternalIdQueryHandler {
    public constructor(
        http: Http
    ) { }
}
